export const ISSUETYPE = {
  BUG: 0,
  TASK: 1,
  TESTING: 2,
  DESIGNING: 3,
  OTHERS: 4,
  MEETING: 5,
  DEPLOYMENT: 6,
};

export const PRIORITY = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const STATUS = {
  TODO: 0,
  INPROGRESS: 1,
  QA: 2,
  PRODUCTION: 3,
  STAGING: 4,
  PENDING: 5,
  UAT: 6,
};

export const VERIFY_STATUS = {
  COMPLETED: 0,
  REOPEN: 1,
};

export const REQUEST_STATUS = {
  COMPLETED: 1,
  ACKNOWLEDAGED: 2,
  PENDING: 3,
};

export const TODO_TASK_PRIORITY = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const TODO_TASK_STATUS = {
  PENDING: 0,
  COMPLETED: 1,
  CANCELED: 2,
  ACKNOWLEDGE: 3,
};
